module.exports = __webpack_public_path__ + "media/images/landing/avatar8-eada7eb307bf60adc94ce0a394e86bc9.jpg";